
import Hero from '@/components/personal-chef-services/Hero'
import MyPassion from '@/components/personal-chef-services/MyPassion'
import ExploreYourOptions from '@/components/shared/ExploreYourOptions'
import WhatOthersAreSayingLarge from '@/components/shared/WhatOthersAreSayingLarge'
import FAQs from '@/components/personal-chef-services/FAQs'
import HaveQuestionsContainer from '@/components/personal-chef-services/HaveQuestionsContainer'
export default {
  name: 'PersonalChefServicesPage',
  components: {
    HaveQuestionsContainer,
    FAQs,
    WhatOthersAreSayingLarge,
    ExploreYourOptions,
    MyPassion,
    Hero,
  },
  layout: 'noheader',
  data() {
    return {
      title: `Plant-Based Personal Chef Services in Lisbon, Portugal | ${this.$config.siteTitle}`,
      description:
        'Nourish your body and soul with expertly crafted plant-based food. We offer small-group catering, cooking classes, and at-home support.',
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/personal-chef/og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/personal-chef/og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1200',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '630',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return `${this.$config.baseURL}${this.$route.fullPath}`
    },
  },
}
